import { useRouteError, useNavigate } from "react-router-dom";
import { useAuth } from "../Hooks/useAuth";
import { useEffect } from "react";
import { Button } from "@mui/material";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    if (error?.response?.status === 401) {
      logout(() => {
        navigate("/login");
      });
    }
  }, [logout, navigate, error]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", top: "50%" }}>
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
        <Button variant="contained" onClick={() => navigate("/")}>
          Hem
        </Button>
      </div>
    </div>
  );
}
